/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import BehavioralAnalytics from 'common/debug/behavioral-analytics';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import { EnablePluginResponse, PluginModel, StandardThunkAction } from 'types';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { LOAD_PLUGINS_SUCCESS } from 'modules/loaders';
// eslint-disable-next-line no-restricted-imports
import {
  enablePluginErrorAction,
  enablePluginRequestAction,
  enablePluginSuccessAction,
} from 'modules/state/ui';

export type PluginsState = PluginModel[];

const initialState: PluginsState = [];

export default createReducer(initialState, {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [LOAD_PLUGINS_SUCCESS](state, { payload }: any) {
    return payload;
  },
});

export const enablePlugin = ({
  idBoard,
  idPlugin,
  trackingName,
}: {
  idBoard: string;
  idPlugin: string;
  trackingName?: string;
}): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(enablePluginRequestAction());
      const response = await API.client.rest.post<EnablePluginResponse>(
        `boards/${idBoard}/boardPlugins`,
        {
          body: { idPlugin },
        },
      );

      let referrer = '';

      if (document.referrer) {
        try {
          referrer = new URL(document.referrer).host;
        } catch (e) {
          // Not a big deal. Continue.
        }
      }

      Analytics.trackUE({
        category: Noun.POWER_UPS_DIRECTORY,
        verb: Verb.ENABLES,
        directObj: Noun.POWER_UP,
        method: 'enable button',
        context: { idPlugin, referrer },
      });

      BehavioralAnalytics.sendTrackEvent({
        action: 'added',
        actionSubject: 'powerUp',
        attributes: {
          boardId: idBoard,
          powerUpName: trackingName,
        },
        objectType: 'powerUp',
        objectId: idPlugin,
        source: 'addPowerUpButton',
      });

      dispatch(enablePluginSuccessAction(response));
    } catch (err) {
      dispatch(enablePluginErrorAction(JSON.parse(err.originalMessage)));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/plugins.ts